import React, { Component } from "react";
import Pagination from "../../../shared/items/contols/pagination";

class CmsHisoryPaginationControl extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { totalCount, count = 10, page, onChangeStore } = this.props;

    return <Pagination totalCount={totalCount} count={count} page={page} pageRangeDisplayed={25} onHandleChangeStore={onChangeStore} />;
  }
}

export default CmsHisoryPaginationControl;
